export default __webpack_public_path__ + "static/media/logo-TM-mobile.162fd37f.svg";